<template>
	<div id="sheet" v-hotkey="keymap" @mousemove="showToolbar()">

		<div v-if="loading" style="margin-top: 5em">
			Loading...
		</div>
		<nav v-if="!loading" v-show="!toolbar.hidden" @mouseenter="toolbar.mouseIsOver = true"
				 @mouseleave="toolbar.mouseIsOver = false" class="navbar navbar-dark bg-dark justify-content-between">
			<a class="navbar-brand">{{song.titles.join("/")}}</a>
			<form class="form-inline">
				<b-button @click="previous()" class="ml-1">Previous</b-button>
				<b-button @click="next()" class="ml-2">Next</b-button>
				<b-button @click="toggleFullscreen()" class="ml-4">Toggle Fullscreen</b-button>

				<input class="form-control ml-4 mr-2" type="password" placeholder="PIN"
							 style="width: 65px; text-align: center; display: inline-block" minlength="4" maxlength="4" v-model="pin">
				<file-upload
					ref="upload"
					name="file"
					v-model="files"
					:post-action="'/rest/v1/songs/' + id + '/sheet'"
					drop="#sheet"
					:headers="{Authorization:'PIN ' + this.pin}"
					@input-file="inputFile"
					v-if="!exists"
					accept="application/pdf"
				>
					<b-button v-show="!$refs.upload || !$refs.upload.active" variant="success" :disabled="pin.length !== 4">Upload
						sheet...
					</b-button>
					<b-button v-show="$refs.upload && $refs.upload.active" variant="success" disabled>Uploading...</b-button>

				</file-upload>
				<b-button variant="danger" v-if="exists" @click="beforeDelete" class="mr-2" :disabled="pin.length !== 4">
					Remove
				</b-button>
				<b-button variant="primary" v-if="exists" @click="download()">Download</b-button>
				<router-link class="btn btn-secondary mx-2" :to="{name: 'lyrics', params: {id: id, lang: song.languages[0]}}">Close</router-link>
			</form>
		</nav>
		<div v-if="!loading && !exists">
			<p class="text-center" style="margin-top: 5em">
				In order to upload notes, enter PIN, and either use "Upload sheet" button or simply drag and drop it here.
			</p>
		</div>
		<div v-if="!loading && exists">
			<pdf :url="pdfUrl" :two-page="true" ref="pdf"></pdf>
		</div>
	</div>
</template>

<script>
	import FileUpload from 'vue-upload-component'
	import axios from '../ConfiguredAxios'
	import Pdf from "../components/Pdf.vue"

	export default {
		components: {
			FileUpload,
			Pdf
		},
		data() {
			return {
				id: 0,
				loading: true,
				exists: false,
				pin: "",
				files: [],
				fullscreen: false,
				toolbar: {
					hidden: true,
					mouseIsOver: false,
					timeoutHandle: null
				},
				song: {
					titles: [],
					hasFile: false,
					languages: []
				}
			}
		},
		methods: {
			inputFile(newFile, oldFile) {
				if (newFile && !oldFile) {
					this.$refs.upload.active = true
				} else if (newFile && oldFile && !newFile.active && oldFile.active && newFile.xhr) {
					if (newFile.xhr.status === 401) {
						alert("Entered PIN is not correct.")
					} else if (newFile.xhr.status !== 204) {
						alert("Unknown error occurred (" + newFile.xhr.status + ")")
					}
					this.load()
				}
			},
			download() {
				window.location.href = window.location.origin + '/rest/v1/songs/' + this.id + '/sheet'
			},
			beforeDelete() {
				if (confirm("Are you sure?")) {
					this.delete()
				}
			},
			delete() {
				this.loading = true
				axios.delete("/rest/v1/songs/" + this.id + "/sheet", {
					headers: {
						"Authorization": "PIN " + this.pin
					}
				}).then(response => {
					this.load()
				})
			},
			load() {
				this.loading = true
				axios.get("/rest/v1/songs/" + this.id).then(response => {
					this.loading = false
					this.song = {

						languages: Object.keys(response.data.lyrics),
						hasFile: response.data.hasFile,
						titles: Object.values(response.data.lyrics).map(lyrics => lyrics.title)
					}
					this.exists = this.song.hasFile
					this.showToolbar()
				})
			},
			previous() {
				this.$refs.pdf.$emit("PreviousPage")
			},
			next() {
				this.$refs.pdf.$emit("NextPage")
			},
			showToolbar() {
				if (this.toolbar.timeoutHandle) {
					clearTimeout(this.toolbar.timeoutHandle)
				}

				if (this.toolbar.hidden) {
					this.toolbar.hidden = false
				}

				if (!this.toolbar.mouseIsOver) {
					this.toolbar.timeoutHandle = setTimeout(() => this.toolbar.hidden = true, 2000)
				}
			},
			toggleFullscreen() {
				if (this.fullscreen) {
					this.closeFullscreen()
				} else {
					this.openFullscreen()
				}
			},
			openFullscreen() {
				if (this.$el.requestFullscreen) {
					this.$el.requestFullscreen()
					this.fullscreen = true
				} else if (this.$el.mozRequestFullScreen) { /* Firefox */
					this.$el.mozRequestFullScreen()
					this.fullscreen = true
				} else if (this.$el.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
					this.$el.webkitRequestFullscreen()
					this.fullscreen = true
				} else if (this.$el.msRequestFullscreen) { /* IE/Edge */
					this.$el.msRequestFullscreen()
					this.fullscreen = true
				}
			},
			closeFullscreen() {
				if (document.exitFullscreen) {
					document.exitFullscreen()
					this.fullscreen = false
				} else if (document.mozCancelFullScreen) { /* Firefox */
					document.mozCancelFullScreen()
					this.fullscreen = false
				} else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
					document.webkitExitFullscreen()
					this.fullscreen = false
				} else if (document.msExitFullscreen) { /* IE/Edge */
					document.msExitFullscreen()
					this.fullscreen = false
				}
			}
		},
		mounted() {
			this.id = this.$route.params.id
			this.load()
		},
		computed: {
			pdfUrl() {
				return window.location.origin + "/rest/v1/songs/" + this.id + "/sheet"
			},
			keymap() {
				return {
					"left": () => {
						this.previous()
					},
					"right": () => {
						this.next()
					},
					"space": () => {
						this.next()
					},
					"f": () => {
						this.toggleFullscreen()
					}
				}
			}
		}
	}
</script>

<style scoped>
	#sheet {
		background: #000;
		color: #fff;
		width: 100%;
		height: 100%;
		max-height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 10;
	}

	#sheet nav {
		position: absolute;
		width: 100%;
		background: rgba(0, 0, 0, 0.7) !important
	}

	#sheet > div {
		height: 100%;
		max-height: 100%;
	}

	#sheet > div > div {
		height: 100%;
		max-height: 100%;
	}
</style>
